import * as Sentry from "@sentry/react";
import { ENVIRONMENT, SENTRY_DSN } from "@config";

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    // tracePropagationTargets: ["alloweat.be", /^https:\/\/api\.alloweat\.be\/api/, "alloweat.app", /^https:\/\/api\.alloweat\.app\/api/],
    environment: ENVIRONMENT,
    enabled: ENVIRONMENT !== "local",
    replaysOnErrorSampleRate: 1.0,
  });

  window.onunhandledrejection = event => {
    Sentry.captureException(event.reason);
  };
  window.onerror = (msg, src, line, col, err) => {
    Sentry.captureException(err);
  };
}
